module.exports = __webpack_public_path__ + "static/tgc-logo-2d6fbcb651addd525db1a3e91a729d82.png";